import React, {
  Fragment,
  useRef,
  useState,
  useContext,
  createContext,
  useEffect,
} from "react";
import { motion, AnimatePresence, useAnimation } from "framer-motion";
import CodeEditor from "@uiw/react-textarea-code-editor";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import loadingCircleImg from "../../../../images/misc/loading-circle-green.svg";
import landmarkImg from "../../../../images/landmark/logo-text-dark.png";
import ApiService from "../../../../services/ApiService";
import PageHeaderBar from "../../../layouts/PageHeaderBar";

import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import PersonIcon from "@mui/icons-material/Person";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import { Box, Button } from "@mui/material";

import { TypeAnimation } from "react-type-animation";
import {
  areSetsEqual,
  copyTextToClipboard,
  useDocumentTitle,
} from "../../../utils";
import { ThemeContext } from "../../../../context/ThemeContext";
import {
  addOneMonth,
  arraysAreEqual,
  epochToDateString,
  epochToDateTimeString,
  formatDateToUS,
  stringToRGB,
  toTitleCase,
} from "../../../../utils";
import { enUS } from 'date-fns/locale';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import r from "react-linear-gradient-picker";
import { useAuth } from "../../../Providers/LandmarkAuthContext";
import EmployeeInfo from "./EmployeeInfo";


const FilterInput = ({ filterKey, placeholder, handleSetFilter, filters }) => {
  const value = filters[filterKey] ? filters[filterKey] : "";
  return (
    <input
      onChange={(e) => handleSetFilter(filterKey, e.target.value)}
      type="text"
      className="form-control filter-input"
      placeholder={placeholder}
      value={value}
    ></input>
  );
};

const FilterOption = ({
  filterKey,
  title,
  optionsEnum,
  handleSetFilter,
  filters,
}) => {
  const value = filters[filterKey] ? filters[filterKey] : "All";
  return (
    <div className="filter-option">
      <div className="input-group">
        <span className="input-group-text">
          <div className="option-title">{title}: </div>{" "}
        </span>
        <select
          defaultValue={"All"}
          className="form-control rmono"
          onChange={(e) => handleSetFilter(filterKey, e.target.value)}
          value={value}
        >
          <option>All</option>
          {Object.entries(optionsEnum).map(([key, status]) => {
            return <option>{toTitleCase(status)}</option>;
          })}
        </select>
      </div>
    </div>
  );
};

const FilterCheckbox = ({ title, checked, handleChecked }) => {
  return (
    <div className="filter-option">
      <div className="input-group">
        <span className="input-group-text">
          <div className="option-title">{title}</div>
        </span>
        <div
          className="form-check custom-checkbox checkbox-success check-lg bs_exam_topper"
          // style={{ marginLeft: "4px" }}
        >
          <input
            type="checkbox"
            className="form-check-input"
            id={`FilterCheckbox_${title}`}
            required
            checked={checked}
            onChange={(event) => handleChecked(event)}
          />
        </div>
      </div>
    </div>
  );
};

const MasterEventsTable = ({
  employee,
  opportunities,
}) => {
  const [selectedOpportunities, setSelectedOpportunities] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [filters, setFilters] = useState({});
  const [filtersEnabled, setFiltersEnabled] = useState(true);
  const [approvedAttendingFilter, setApprovedAttendingFilter] = useState(false);
  const [notHandledFilter, setNotHandledFilter] = useState(true);
  const [handledFilter, setHandledFilter] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [recipientEmail, setRecipientEmail] = useState(employee ? employee.email : "");
  const [generatedOpportunityIds, setGeneratedOpportunityIds] = useState([]);
  const [loadingOpportunityIds, setLoadingOpportunityIds] = useState([]);

  async function generateAppetizerBatch(opportunityIds) {
    try {
      if (!employee) {
        toast.error(`Employee not logged in`);
        return;
      }
       if (!opportunityIds || !opportunityIds.length) {
        toast.error(`No opportunities selected`);
        return;
      }
      if(!recipientEmail || recipientEmail.length < 5) {
        toast.error(`Please enter a valid recipient email`);
        return;
      }
      setLoadingOpportunityIds(prev => [...prev, ...opportunityIds]);
      const api = new ApiService({ employee, employee });
      const { success, error } = await api.post(
        `landmark/salesforce/generateAppetizerBatch`,
        {
          opportunityIds,
          recipientEmail,
        });
      if (!success && error) {
        toast.error(`${error}`);
      } 
    else if (success) {
      toast.success(`${success}`);
      setGeneratedOpportunityIds(prev => [...prev, ...opportunityIds]);
    }
      else {
        toast.error(`An error occurred: ${error}`);
      }
  } catch (error) {
    console.error(error);
  }
    finally {
      setLoadingOpportunityIds((prev) => {
        return prev.filter((id) => !opportunityIds.includes(id));
      });
    }
}

  const handleSetUnhandledFilter = (event) => {
    const checked = event.target.checked;
    setNotHandledFilter(checked);
  };

  const handleSetCreatedFilter = (event) => {
    const checked = event.target.checked;
    setHandledFilter(checked);
  };

  const handleSetFiltersEnabled = (event) => {
    const checked = event.target.checked;
    setFiltersEnabled(checked);
  };

  const getFilteredOpportunities = () => {
    function isString(s) {
      return typeof s === "string" || s instanceof String;
    }

    // filter just the opportunities for the selected event
    let filtered = opportunities.sort((a, b) => {
      return new Date(a.Phase_1_Date__c) - new Date(b.Phase_1_Date__c);
    });

    // bypassed
    if (!filtersEnabled) {
      return filtered;
    }

    console.log(`getFilteredOpportunities() - filters`, filters);

    for (const filterKey in filters) {
      let filterValue = filters[filterKey];

if (filterKey === "Phase_1_Date__c" && filterValue) {
  const date = new Date(filterValue);
  const year = date.getFullYear(); // local time
  const month = String(date.getMonth() + 1).padStart(2, '0'); // local time
  const day = String(date.getDate()).padStart(2, '0'); // local time
  filterValue = `${year}-${month}-${day}`;
}

      // string filtering
      if (isString(filterValue) && filterValue.length > 0) {
          filtered = filtered.filter((opportunity) =>
            opportunity[filterKey].toLowerCase().includes(filterValue.toLowerCase())
            );
      }
    }

    if (notHandledFilter && handledFilter) {
      // show all (no added filtering)
    }
    // uncontacted only filter
    else if (notHandledFilter && !handledFilter) {
      //filtered = filtered.filter((opportunity) => !opportunity.quickbooksHandled);
    }
    // contacted only filter
    else if (handledFilter && !notHandledFilter) {
      //filtered = filtered.filter((opportunity) => opportunity.quickbooksHandled);
    } else {
      // show all (no added filtering)
    }

    return filtered;
  };
  let filteredOpportunities = getFilteredOpportunities();

  const copyText = (text, desc = null) => {
    copyTextToClipboard(text);
    desc = desc ? desc : "text";
    toast.success(`Copied ${desc} to clipboard`);
  };

  let canNextPage = false;
  let canPreviousPage = false;
  const pageCount = Math.ceil(filteredOpportunities.length / rowsPerPage);
  console.log(`pageIndex`, pageIndex);
  console.log(`pageCount`, pageCount);
  if (pageIndex + 1 < pageCount) {
    canNextPage = true;
  }
  if (pageIndex > 0) {
    canPreviousPage = true;
  }

  const goToPage = (pageNo) => {
    if (pageNo >= 0 && pageNo < pageCount) {
      setPageIndex(pageNo);
    } else {
    }
  };
  const nextPage = () => {
    if (canNextPage) {
      setPageIndex(pageIndex + 1);
    }
  };
  const previousPage = () => {
    if (canPreviousPage) {
      setPageIndex(pageIndex - 1);
    }
  };
  // Calculate the start index and end index for the current page
  const startIndex = pageIndex * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  // get opportunities to display on the current page
  const pageOpportunities = filteredOpportunities.slice(startIndex, endIndex);

  if (!filteredOpportunities || !opportunities || !opportunities.length) {
    return <div className="no-opps-text">No Opportunities Loaded</div>;
  }

  // const handleSubmitContactComment = async (
  //   contactOpportunityId,
  //   content,
  //   isReply,
  //   replyCommentId
  // ) => {
  //   try {
  //     if (!employee) {
  //       toast.error(`An error occurred: employee not logged in`);
  //       return;
  //     }
  //     const api = new ApiService({ employee, employee });
  //     const { success, error, info } = await api.post(
  //       `landmark/opportunities/submitEventContactComment`,
  //       {
  //         contactOpportunityId,
  //         employee,
  //         content,
  //         isReply,
  //         replyCommentId,
  //       }
  //     );
  //     if (!success && !info) {
  //       toast.error(`An error occurred: ${error}`);
  //       return false;
  //     } else if (success) {
  //       toast.success(`${success}`);
  //       return true;
  //     } else if (info) {
  //       toast(`${info}`);
  //       return true;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  const selectOpportunities = (opportunitiesToSelect) => {
    const newSelectedOpportunities = [...selectedOpportunities];
    opportunitiesToSelect.forEach((inv) => {
      if (!newSelectedOpportunities.includes(inv.Id)) {
        newSelectedOpportunities.push(inv.Id);
      }
    });
    setSelectedOpportunities(newSelectedOpportunities);
  };

  const unselectOpportunities = (opportunitiesToUnselect) => {
    opportunitiesToUnselect = opportunitiesToUnselect.map((r) => r.Id);
    setSelectedOpportunities((prevSelectedOpportunities) => {
      return prevSelectedOpportunities.filter(
        (r) => !opportunitiesToUnselect.includes(r)
      );
    });
  };

  const toggleSelectAllPageOpportunities = (event) => {
    console.log(`toggleSelectAllPageOpportunities() - event.target`, event.target);
    const checked = event.target.checked;
    // select all opportunities on this page
    if (checked) {
      selectOpportunities(pageOpportunities);
    }
    // unselect all opportunities on this page
    else {
      unselectOpportunities(pageOpportunities);
    }
  };
  const toggleSelectOpportunity = (event, opportunity) => {
    const checked = event.target.checked;
    console.log(`toggleSelectOpportunity() - checked`, checked);
    if (checked) {
      selectOpportunities([opportunity]);
    } else {
      unselectOpportunities([opportunity]);
    }
  };

  const handleSetFilter = (filterKey, value) => {
    const newFilters = { ...filters };
    newFilters[filterKey] = value;
    setFilters(newFilters);
  };

  let headers = [];
  // Assuming opportunities is not an empty array
  if (opportunities.length > 0) {
    const headersSet = new Set();
    opportunities.forEach((r) => {
      Object.keys(r).forEach((key) => {
        headersSet.add(key);
      });
    });

    headers = Array.from(headersSet).map((h) => {
      return { key: h, name: h };
    });
    // remove unwanted fields
    const unwanted = [
      "attendanceStatusUpdates",
      "comments",
      "confirmEmails",
      "optionRequests",
      "__v",
      "_id",
      "partnerResponses",
    ];
    headers = headers.filter((h) => !unwanted.includes(h.key));
    console.log(`headers`, headers);
  }

  const selectAllBtn = () => {
    // unselect all
    unselectOpportunities(opportunities);
    // selected all filtered
    selectOpportunities(filteredOpportunities);
    toast.success(`${filteredOpportunities.length} opportunities selected`);
  };

  const unselectAllBtn = () => {
    // unselect all
    unselectOpportunities(opportunities);
  };

  // const sendEmailToSelectedContactsBtn = () => {
  //   sendContactEmail(selectedOpportunity.Id, selectedOpportunities);
  //   unselectOpportunities(opportunities);
  // };

  return (
    <>
      {opportunities && opportunities.length ? (
        <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
          <Card className="mb-3 h-fc bot-table">
            {/* <div className="event-image-img">
              <img src={selectedOpportunity.imageUrl} className="img-fluid" />
            </div> */}
            <div className="row">
              <div className="outputHeader">Generate Appetizers</div>
              <div className="events-owners-subheading">
                Filter opportunities and generate Appetizers

                {/* Recommended workflow:
                <ul>
                <li>• Filter the data based on event (or company, etc.)</li>
                <li>
                • Click 'Export Current' to export the filtered data to a
                spreadsheet
                </li>
                <li>• Once handled, click 'Mark Current as Handled'</li>
              </ul> */}
              </div>
               <div className="filters-row">
                            <div className="filter-option">
                            <div className="input-group">
                      <span className="input-group-text">
                        <div className="option-title">Appetizer Recipient (must have a Salesforce account): </div>{" "}
                      </span>
                      <input
      onChange={(e) => setRecipientEmail(e.target.value.trim())}
      type="text"
      className="form-control filter-input"
      placeholder="Email"
      value={recipientEmail}
    ></input>
                    </div>
                    </div>
                    </div>
              <>
                <></>
                <div className="outputBody">
                  <div className="table-wrapper">
                    {
                      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
                        <div
                          className={`table-wrapper ${
                            filtersEnabled ? "" : "filters-disabled"
                          }`}
                        >
                          <div className="filters-enable-row">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="filterBypassSwitch"
                                checked={filtersEnabled}
                                onChange={(e) => handleSetFiltersEnabled(e)}
                              ></input>
                              <label
                                className="form-check-label enable-filters-label"
                                htmlFor="filterBypassSwitch"
                              >
                                Enable Filters
                              </label>
                            </div>
                          </div>
                          <div className="filters-row">
                            <div className="filter-option">
                            <div className="input-group">
                      <span className="input-group-text">
                        <div className="option-title">Name: </div>{" "}
                      </span>
                      <FilterInput
                    
  filterKey="Name"
  placeholder=""
  filters={filters}
  handleSetFilter={handleSetFilter}
/>
                    </div>
                    </div>
                         

{/* <FilterInput
  filterKey="Id"
  placeholder="Opportunity ID"
  filters={filters}
  handleSetFilter={handleSetFilter}
/> */}
                            <div className="filter-option">
                            <div className="input-group" style={{ flexDirection: "column" }}>
                      <span className="input-group-text">
                        <div className="option-title">Phase 1 Date: </div>{" "}
                      </span>
<DatePicker 
className="form-control filter-input"
              selected={filters['Phase_1_Date__c'] ? filters['Phase_1_Date__c'] : ""}
              onChange={(date) => handleSetFilter("Phase_1_Date__c", date)}
              locale={enUS}
              dateFormat="P"
            />
             </div>
                    </div>

                          </div>
                          <div className="filters-row">
                            {/* <FilterCheckbox
                              title="Approved and Attending (includes Tentative):"
                              checked={approvedAttendingFilter}
                              handleChecked={handleSetApprovedAttendingFilter}
                            /> */}
                            {/* <FilterCheckbox
                              title="Not Handled:"
                              checked={notHandledFilter}
                              handleChecked={handleSetUnhandledFilter}
                            />
                            <FilterCheckbox
                              title="Handled:"
                              checked={handledFilter}
                              handleChecked={handleSetCreatedFilter}
                            /> */}
                          </div>
                        </div>
                      </motion.div>
                    }
                    {
                      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
                        <div className="table-wrapper">
                          <div
                            className="events-owners-subheading"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Totals${filtersEnabled ? ` (filtered)` : ``}`}
                          </div>
                          <div className="totals-row rmono">
                            <div className="total-col">
                              <div className="total-line">
                                <div className="field">Opportunities: </div>
                                <div className="value">
                                  {filteredOpportunities.length}
                                </div>
                              </div>
                              <div className="total-line option col-black fw-500">
                                <div className="field">Selected: </div>
                                <div className="value">
                                  {selectedOpportunities.length}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    }
                    {
               
                        <div className="select-btns-container mt-3">
                          <button
                            className={`create-event-btn btn btn-sm btn-primary email-options-btn mr-10`}
                            onClick={selectAllBtn}
                          >
                            {`Select All`}
                            {/* <i className="event-owner-add fa-sharp fa-solid fa-user ml-05"></i> */}
                          </button>
                          <button
                            className={`create-event-btn btn btn-sm btn-primary email-options-btn bulk-email-btn mr-10 ${
                              selectedOpportunities.length ? `` : ` disabled`
                            }`}
                            onClick={unselectAllBtn}
                          >
                            {`Unselect All`}
                          </button>
                            
                        <button
                          className={`create-event-btn btn btn-sm btn-primary email-options-btn bulk-email-btn handled-btn mr-10${
                            selectedOpportunities.length && !loadingOpportunityIds.length ? `` : ` disabled`
                          }`}
                          onClick={() => generateAppetizerBatch(selectedOpportunities)}
                        >
                          {selectedOpportunities.some(op => loadingOpportunityIds.includes(op)) ? (
                            <div className="text-center">
                              <img
                                className="m-auto"
                                width={74}
                                src={loadingCircleImg}
                              />
                            </div>
                          ) : (
                            <>
                              Generate Appetizers for Selected
                              <i className="event-owner-add fa-sharp fa-solid fa-envelope ml-05"></i>
                            </>
                          )}
                        </button>

                  
                        </div>
                    }
                    
                    <Table
                      responsive
                      className="opportunity-dashboard-table header-border "
                    >
                      <thead>
                        <tr>
                          <th className="width50 ">
                            <div className="form-check custom-checkbox checkbox-success check-lg me-3 bs_exam_topper_all">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="checkAll"
                                required
                                defaultChecked={false}
                                checked={
                                  !pageOpportunities.some(
                                    (pr) =>
                                      !selectedOpportunities.includes(
                                        pr.Id
                                      )
                                  )
                                }
                                onChange={toggleSelectAllPageOpportunities}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkAll"
                              ></label>
                            </div>
                          </th>
                          <th>Opportunity</th>
                          <th>Phase 1 Date</th>
                          <th>Generate Appetizer</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {pageOpportunities.map((opportunity, i) => {
                          const {
                            Client_Owner__c,
                            CloseDate,
                            Id,
                            Name,
                            Phase_1_Date__c,
                            StageName,
                          } = opportunity;

                          return (
                            <tr
                              key={`tr_row_${i}`}
                            >
                              <td>
                                <div className="form-check custom-checkbox checkbox-success check-lg me-3 bs_exam_topper">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckBox2"
                                    required
                                    defaultChecked={false}
                                    checked={selectedOpportunities.includes(
                                      opportunity.Id
                                    )}
                                    onChange={(event) =>
                                      toggleSelectOpportunity(event, opportunity)
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <a
                                  className="inv-link"
                                  href={`https://landmarkventures.lightning.force.com/lightning/r/Opportunity/${Id}/view`}
                                  target="_blank"
                                >
                                  <b>{Name}</b>
                                </a>
                              </td>
                              <td>
                                 {formatDateToUS(Phase_1_Date__c)}
                              </td>
                              <td>
                               { generatedOpportunityIds.includes(opportunity.Id) ? (<div className="appetizer-generated-text">
                               {`✅ Appetizer Generated`}
                               </div>) :  
                               <button
                                   className={`sign-up-btn btn btn-sm btn-primary export-csv-btn`}
                                   onClick={() =>
                                     generateAppetizerBatch([opportunity.Id])
                                   }
                                 >
                                    {loadingOpportunityIds.includes(opportunity.Id) ? (<div className="text-center">
                                  <img
                                    className="m-auto"
                                    width={74}
                                    src={loadingCircleImg}
                                  />
                                </div>): (<>{`Generate Appetizer`}
                                  <i className="event-owner-add fa-sharp fa-solid fa-envelope ml-05"></i></>
                                )}
                                </button>}
                              </td>
                            
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-between">
                      <span className="table-index">
                        Page{" "}
                        <strong>
                          {pageIndex + 1} of {pageCount}
                        </strong>
                        {""}
                      </span>
                      <span className="table-index">
                        Rows per page :{" "}
                        <input
                          type="number"
                          className="ml-2"
                          defaultValue={rowsPerPage}
                          min={1}
                          max={500}
                          onChange={(e) => {
                            setRowsPerPage(Number(e.target.value));
                          }}
                        />
                      </span>
                      <span className="table-index">
                        Go to page :{" "}
                        <input
                          type="number"
                          className="ml-2"
                          defaultValue={pageIndex + 1}
                          min={1}
                          max={pageCount}
                          onChange={(e) => {
                            const pageNumber = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            goToPage(pageNumber);
                          }}
                        />
                      </span>
                    </div>
                    <div className="text-center mb-3">
                      <div className="filter-pagination  mt-3">
                        <button
                          className=" previous-button"
                          onClick={() => goToPage(0)}
                          disabled={!canPreviousPage}
                        >
                          {"<<"}
                        </button>

                        <button
                          className="previous-button"
                          onClick={() => previousPage()}
                          disabled={!canPreviousPage}
                        >
                          Previous
                        </button>
                        <button
                          className="next-button"
                          onClick={() => nextPage()}
                          disabled={!canNextPage}
                        >
                          Next
                        </button>
                        <button
                          className=" next-button"
                          onClick={() => goToPage(pageCount - 1)}
                          disabled={!canNextPage}
                        >
                          {">>"}
                        </button>
                      </div>
                    </div>
      
                  </div>
                </div>
              </>
              {!opportunities ? (
                <div className="text-center">
                  <img
                    className="m-auto mt-3 mb-3"
                    width={74}
                    src={loadingCircleImg}
                  />
                </div>
              ) : null}
            </div>
          </Card>
        </motion.div>
      ) : (
        <div className="no-opportunities-msg">No opportunities found for this event</div>
      )}
    </>
  );
};
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const PasswordPrompt = ({ employee, setPassword, submitPassword }) => {
  const handleInputChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitPassword(employee);
  };

  return (
    <div className="d-flex">
      <input
        onChange={handleInputChange}
        type="employee"
        className="form-control w-100 mt-1 inline-input"
        placeholder="Password"
        value={employee}
      ></input>
      <div
        className="btn btn-primary light btn-xs mt-1 me-1 w-fc inline-btn"
        onClick={(e) => handleSubmit(e)}
      >
        Submit
      </div>
    </div>
  );
};

const SelectTasks = ({ employee, selectedOpportunity, refreshOpportunity }) => {
  const [tasks, setTasks] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);

  async function getTasks() {
    try {
      const api = new ApiService({ employee });
      const response = await api.get(
        `landmark/seamlessbot/getValidKeywordTasks`
      );
      console.log(`landmark/seamlessbot/getValidKeywordTask`, response);
      setTasks(response);
    } catch (error) {
      console.error(error);
    }
  }

  async function saveSeamlessTaskChanges() {
    try {
      const api = new ApiService({ employee });
      const response = await api.post(
        `landmark/opportunities/editOpportunitySeamlessTasks`,
        {
          Id: selectedOpportunity.Id,
          seamlessBotTaskIds: selectedTasks,
        }
      );
      console.log(`landmark/opportunities/editOpportunitySeamlessTasks`, response);
      const { success, error } = response;
      if (!success) {
        toast.error(`An error occurred: ${error}`);
        return false;
      } else if (success) {
        toast.success(`${success}`);
        // update opportunity object
        refreshOpportunity(selectedOpportunity.Id);
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getTasks();
  }, []);

  useEffect(() => {
    setSelectedTasks(selectedOpportunity.seamlessBotTaskIds);
  }, [selectedOpportunity]);

  function toggleSelectTask(taskId) {
    if (selectedTasks.includes(taskId)) {
      setSelectedTasks(selectedTasks.filter((t) => t !== taskId)); // remove task
    } else {
      const newSelectedTasks = selectedTasks.filter((t) => true); // clone list
      newSelectedTasks.push(taskId); // add task
      setSelectedTasks(newSelectedTasks);
    }
  }

  const existingTaskIds = new Set(selectedOpportunity.seamlessBotTaskIds);
  const newTaskIds = new Set(selectedTasks);
  const tasksHaveChanged = !areSetsEqual(existingTaskIds, newTaskIds);

  return (
    <>
      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
        <Card className="mb-3 h-fc bot-table">
          <div className="row">
            <div className="outputHeader">Import Contacts</div>
            <>
              <div className="events-owners-subheading">
                Select Keyword Bot Tasks to import opportunities
              </div>
              <div
                className="event-owners-wrapper"
                style={{ marginBottom: "12px" }}
              >
                {tasks.map((task) => {
                  const selectedClass =
                    selectedOpportunity && selectedTasks.includes(task.taskId)
                      ? "selected"
                      : "";
                  return (
                    <div key={task.taskId}>
                      <div
                        className={`event-owner-container selectable ${selectedClass}`}
                        onClick={() => toggleSelectTask(task.taskId)}
                      >
                        {/* <img
                          src={event.imageUrl}
                          className="img-fluid event-img"
                        /> */}
                        <div className="event-title">{task.keyword}</div>
                        <div className="event-description">
                          {`${task.opportunitiesCount} opportunities`} <br></br>
                          {task.lastRunTime
                            ? epochToDateString(task.lastRunTime)
                            : epochToDateString(task.createdTime)}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {tasksHaveChanged ? (
                <div className="centered-flex-row ">
                  <button
                    className={`create-event-btn save-changes-btn btn btn-sm btn-primary mb-4`}
                    onClick={saveSeamlessTaskChanges}
                  >
                    {`Save Changes`}
                    <i className="event-owner-add fa-sharp fa-solid fa-check ml-05"></i>
                  </button>
                </div>
              ) : null}
            </>
          </div>
        </Card>
      </motion.div>
    </>
  );
};

const SalesforceScanner = ({
  employee,
  loadOpportunities,
}) => {
  const [showEditTemplate, setShowEditTemplate] = useState(false);
  const [clientTeam, setClientTeam] = useState("Team 1 - IT");
  const [stage, setStage] = useState("Phase 0 (Pre-Meeting)");  
  const [loading, setLoading] = useState(false);
  const [opportunitiesLoadedSettings, setOpportunitiesLoadedSettings] = useState({});

  // async function createTemplate() {
  //   try {
  //     const api = new ApiService({ employee, employee });
  //     const newTemplate = await api.post(
  //       `landmark/salesforce/createTemplate`,
  //       {
  //         employee,
  //         Id: selectedOpportunity.Id,
  //       }
  //     );
  //     // refresh templates
  //     await getTemplates();
  //     setSelectedEmailTemplate(newTemplate);
  //     setShowEditTemplate(true);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  const clientTeamOptions = [
    'Team 1 - IT',
    'Team 2 - Industrial Tech',
    'Team 3 - Digital Media',
    'Team 4 - Cybersecurity',
    'Team 5','Investment Banking',
  ]
  
  const stageOptions = [
    'Phase 0 (Pre-Meeting)',
    'Phase 1',
    'Phase 2',
    'Phase 3',
    'Phase 4',
    'Phase 5',
  '0. Initiate Contact',
  '0. Pending',
  '1. Intro Meeting',
  '1. Lead',
  '1. Meeting With Client',
  '1. Sent Teaser',
  '1.Sent Teaser',
  '2. In Review',
  '2. Prospect Analysis',
  '2. Qualified Lead',
  '3. Intro Meeting',
  '3. Pitch Deck',
  '3. Verified Opportunity',
  '4. Closeable Opportunity',
  '4. Deep Dive',
  '4. Due Diligence',
  '5. Engagement Letter',
  '5. Term Sheet / IOI / LOI',
  'Closed Lost',
  'Closed Won',
  'Confirmed',
  'Declined',
  'Engaged',
  'Finalizing',
  'Interested',
  'On Hold',
  'Passed',
  'Requested/Offered to Speak',
  'Responsive',
  'Soft Confirmed - Do Not Publish'
]


  return (
    <>
      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
        <Card className="mb-3 h-fc bot-table">
          <div className="row">
            <div className="outputHeader">Opportunities</div>
            <>
              <div className="events-owners-subheading">
                Load upcoming opportunities from Salesforce
              </div>
               <div className="filters-row">
               <div className="filter-option">
                    <div className="input-group">
                      <span className="input-group-text">
                        <div className="option-title">Client Team: </div>{" "}
                      </span>
                      <select
                        defaultValue={"All"}
                        className="form-control rmono"
                        onChange={(e) => setClientTeam(e.target.value)}
                        value={clientTeam}
                      >
                        {clientTeamOptions.map(team => {
                          return (
                            <option>{team}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>  <div className="filter-option">
                    <div className="input-group">
                      <span className="input-group-text">
                        <div className="option-title">Stage: </div>{" "}
                      </span>
                      <select
                        defaultValue={"All"}
                        className="form-control rmono"
                        onChange={(e) => setStage(e.target.value)}
                        value={stage}
                      >
                        {stageOptions.map(st => {
                          return (
                            <option>{st}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
</div>

                               
              <div className="email-template-button-container">
                <div className="add-edit-btn-container">
                  {}
                  <button
                    className={`create-event-btn btn btn-sm btn-primary email-options-btn`}
                   onClick={() => loadOpportunities({
                    Client_Owner__c: clientTeam,
                    StageName: stage,
                    Phase_1_Date__c: { op: ">=", value: new Date().toISOString().split('T')[0] }, // today in UTC
                  }, setLoading)}
                  >
                    {loading ? (<div className="text-center">
                      <img
                        className="m-auto"
                        width={74}
                        src={loadingCircleImg}
                      />
                    </div>) : (<>{`Load Opportunities`}
                    <i className="event-owner-add fa-sharp fa-solid fa-magnifying-glass ml-05"></i></>
                    )}
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-center"></div>
            </>
          </div>
        </Card>
      </motion.div>
    </>
  );
};

const Dashboard = () => {
  useDocumentTitle("Appetizer Dashboard - Landmark Ventures");

  const { changeBackground } = useContext(ThemeContext);
  const { employee, isAuthenticated, loading, logout } = useAuth();

  const [opportunities, setOpportunities] = useState([]);

  // Light theme
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, [changeBackground]);

  // (Optional) touch lastSeenTime on backend when authenticated
  useEffect(() => {
    if (!isAuthenticated || !employee) return;
    try {
      const api = new ApiService({ employee });
      api.get("landmark/employees/login"); // fire & forget
    } catch (err) {
      console.warn("employee login touch failed", err);
    }
  }, [isAuthenticated, employee]);

  async function loadOpportunities(filters = {}, setLoading = () => {}) {
    try {
      setLoading(true);
      const api = new ApiService({ employee }); // send employeeId header if your backend still uses it
      const response = await api.post("landmark/salesforce/getOpportunities", { filters });
      const list = Array.isArray(response) ? response : [];
      setOpportunities(list);
      if (list.length === 0) {
        toast.error("No opportunities found");
        return false;
      } else {
        toast.success(`Found ${list.length} opportunities`);
        return true;
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load opportunities");
      return false;
    } finally {
      setLoading(false);
    }
  }

  // Kick off initial loads after auth (optional)
  useEffect(() => {
    if (isAuthenticated) {
      // loadOpportunities();
    }
  }, [isAuthenticated]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border" role="status" aria-label="Loading" />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="global-dash-wrapper opportunity-dash appetizer-wrapper">
        <div className="d-flex align-items-center justify-content-center">
          <img src={landmarkImg} className="img-fluid landmark-img" alt="Landmark" />
        </div>

        {/* Small signed-in badge (optional) */}
        {isAuthenticated && employee && (
        <div className="landmark-sign-in" style={{ marginBottom: "18px" }}>
            <div className="existing-accounts-container">
              <EmployeeInfo landmarkEmployee={employee} disableHover={true} showLogout={true} logout={logout} />
            </div>
          </div>
        )}

        <PageHeaderBar
          pages={[
            { title: "Landmark", url: `` },
            { title: "Appetizer Dashboard", url: `/landmark/appetizer/dashboard` },
          ]}
        />

        {isAuthenticated ? (
          <>
            <SalesforceScanner
              employee={employee}
              loadOpportunities={loadOpportunities}
            />
            <MasterEventsTable
              employee={employee}
              opportunities={opportunities}
            />
          </>
        ) : (
          <div className="text-center text-muted p-5">
            Please sign in to access the dashboard.
          </div>
        )}
      </div>
    </Fragment>
  );
};



export default Dashboard;
